var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinCircleLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35 5C48.2548 5 59 15.7452 59 29H11C11 15.7452 21.7452 5 35 5Z",
    fill: "url(#paint0_linear_2381_6075)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 5C48.2548 5 59 15.7452 59 29C59 42.2548 48.2548 53 35 53C21.7452 53 11 42.2548 11 29C11 15.7452 21.7452 5 35 5ZM35 8C23.402 8 14 17.402 14 29C14 40.598 23.402 50 35 50C46.598 50 56 40.598 56 29C56 17.402 46.598 8 35 8Z",
    fill: "url(#paint1_linear_2381_6075)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2381_6075",
    x1: 35,
    y1: 5,
    x2: 35,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2381_6075",
    x1: 35,
    y1: 5,
    x2: 35,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinCircleLight);
export default __webpack_public_path__ + "static/media/map_pin_circle_light.15d607c0f6dc32514e8672e1a0466784.svg";
export { ForwardRef as ReactComponent };